import { Form , Input, Button , Row} from 'antd';
import React  from 'react';
import { loginAction, getServerUrlByUserName } from '../../actions/login-actions';
import { useDispatch } from 'react-redux';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate , useLocation} from "react-router-dom";
import { TEMP_LOGIN_CREDENTIALS, SERVER_URL_ACCESS_TOKEN_KEY } from '../../utils/constant';
import { updateUrls } from '../../utils/api-url';
import { API_ADMIN_URL, API_TRAVELS_URL } from '../../app.config';
import { isValid } from '../../utils/utilities';

export const  WrappedLoginForm = (props) => {

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate=useNavigate();
    const location = useLocation();

    const  handleSubmit = (e) => {
      e.preventDefault();
      form.validateFields()
      .then(values => {
        getServerUrlByUserName(values.username, (serverUrl) => {
          let travelsServerUrl = API_TRAVELS_URL;
          let adminServerUrl = API_ADMIN_URL;
          if (isValid(serverUrl)) {
            travelsServerUrl = serverUrl.travels_server_url;
            adminServerUrl = serverUrl.admin_server_url;
          }
          let serverUrlString = JSON.stringify({travelsUrl: travelsServerUrl, adminBaseUrl: adminServerUrl});
          localStorage.setItem(SERVER_URL_ACCESS_TOKEN_KEY,serverUrlString);
          localStorage.setItem(TEMP_LOGIN_CREDENTIALS,JSON.stringify(values));
          updateUrls();
          window.location.reload();
          console.log({serverUrl});
        }, (error) => {
          console.log({error});
        });
          // dispatch(loginAction(null,values.username,values.password,{navigate,location}));
      })
      .catch(errorInfo => {
        console.log({errorInfo});
      })
    };

    return (
      <Row type="flex" justify="space-around" style={{margin:'10px'}}>
          <Form className="login-form" form={form}>
            <Form.Item
                    label="User Name"
                    name="username"
                    rules={[{ required: true, message: 'Please input your user name!' }]}
                  >
                    <Input />
            </Form.Item>
            <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your Password!' }]}
                  >
                    <Input.Password
                       iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button"
              onClick={(e)=>{
                handleSubmit(e);
              }}
              >
                Log in
              </Button>
            </Form.Item>
          </Form>
      </Row>
    );
}
